import { getToken } from '@library/token'
import type { AxiosInstance } from 'axios'
import axios from 'axios'

export const baseURL = '/api'

export const axiosInstance = axios.create({
  baseURL,
  responseType: 'json',
})

const addBearer = (instance: AxiosInstance) => {
  instance.interceptors.request.use(config => {
    const token = getToken()
    const access = localStorage.getItem('access')

    if (token) {
      config.headers.authorization = `Bearer ${token}`
      if (access !== null) {
        config.headers.access = access
      }
    }
    return config
  })
}

addBearer(axiosInstance)
